/**
 * Horizontal center of a calendar day within a collapsed month section.
 * Odd days align to column centers; even days sit between adjacent odd columns.
 */
export function getCollapsedDayMidPx(
  day: number,
  visibleOddDays: number[],
  dayWidthPx: number
): number {
  const oddIndex = visibleOddDays.indexOf(day);
  if (oddIndex >= 0) {
    return oddIndex * dayWidthPx + dayWidthPx / 2;
  }

  const prevOdd = [...visibleOddDays].reverse().find(oddDay => oddDay < day);
  const nextOdd = visibleOddDays.find(oddDay => oddDay > day);

  if (prevOdd !== undefined && nextOdd !== undefined) {
    return (
      (getCollapsedDayMidPx(prevOdd, visibleOddDays, dayWidthPx) +
        getCollapsedDayMidPx(nextOdd, visibleOddDays, dayWidthPx)) /
      2
    );
  }

  if (prevOdd !== undefined) {
    return (
      getCollapsedDayMidPx(prevOdd, visibleOddDays, dayWidthPx) + dayWidthPx / 2
    );
  }

  if (nextOdd !== undefined) {
    return Math.max(
      dayWidthPx / 2,
      getCollapsedDayMidPx(nextOdd, visibleOddDays, dayWidthPx) - dayWidthPx / 2
    );
  }

  return dayWidthPx / 2;
}
